import React, {useEffect, useRef, useState} from 'react';
import './styles.scss';

import Header2 from '../../../../components/headers/header2';
import {Column, Row} from '../../../../components/layout';
import ModalTemplate from '../../../../components/modal';
import ExpensesDetail from '../../../../components/expenses-detail';
import ReimbursementListItemStatus from './ReimbursementListItemStatus';
import * as fonts from '../../../../util/fonts';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../../../util/strings';
import ReimbursementSubmissionStatusBar from '../../components/ReimbursementSubmissionStatusBar';
import colors from '../../../../util/colors';
import AppButton from '../../../../components/app-button';
//import {Icons} from '../../../../util/icons';
//import Icon from '../../../../components/icon';
import moment from 'moment';
import AppSpinner from '../../../../components/app-spinner';
import {useMediaQuery} from 'react-responsive';
import {uriGetSinisterDocuments} from '../../../../api/endpoints';
import {get} from '../../../../api/api';
import {getDocuments, getDocumentsForDownload} from '../../../../util/utility';

interface ReimbursementsDetailProps {
  showModal: boolean;
  setShowModal(value: any): void;
  selectedBu: any;
  color: string;
  expenses: any[];
  selectedItem: any;
  user: any;
  labels: typeof strings.pt.refund;
  createRefundLabels: typeof strings.pt.createRefund;
  labelsMessages: typeof strings.pt.messages;
  ReimbursementFinishedSubmitting(values?: any): void;
  setUpdateFlag(value: boolean): void;
  updateFlag: boolean;
  changedItem?: any;
  buStyles: any;
  checkdate?: string;
  statuses: any;
  loadingDetail: boolean;
  isLoading?: boolean;
  errorLoading?: boolean;
  ibanDetails?: any;
  iban?: string;
  loadingPaymentDetail?: boolean;
  language: any;
}

interface IDocsForDownload {
  documentsAttached: any[];
  documentsEmitted: any[];
}

function ReimbursementsDetail({
  showModal,
  setShowModal,
  color,
  expenses,
  selectedItem,
  labels,
  createRefundLabels,
  labelsMessages,
  user,
  selectedBu,
  iban,
  ReimbursementFinishedSubmitting,
  updateFlag,
  setUpdateFlag,
  changedItem,
  checkdate,
  statuses,
  loadingDetail,
  isLoading,
  errorLoading,
  ibanDetails,
  loadingPaymentDetail,
  language,
}: ReimbursementsDetailProps) {
  const isResponsive = useMediaQuery({maxDeviceWidth: 768});
  const featureName = 'ReimbursementDetails';
  const checkLetterRef = useRef<HTMLDivElement | null>(null);

  const [listOfDocuments, setListOfDocuments] = useState<any[]>([]);
  const [listOfDocumentsAttached, setListOfDocumentsAttached] = useState<any[]>(
    [],
  );
  const [listOfDocumentsEmitted, setListOfDocumentsEmitted] = useState<any[]>(
    [],
  );

  let currentStatus = statuses.find(
    (e: any) => e.value == selectedItem.stateId,
  );

  const getReasons = () => {
    let reasons: any[] = [];

    expenses.forEach((item) => {
      item.rejectedReason?.forEach((element: any) => {
        reasons.push(element);
      });
    });

    const uniqueReasons = Array.from(new Set(reasons));
    return uniqueReasons;
  };

  const handleScrollToCheckLetter = () => {
    const el = checkLetterRef.current;
    if (!el) return;

    el.scrollIntoView({behavior: 'smooth', block: 'start'});

    window.setTimeout(() => {
      el.classList.remove('flash-highlight');
      void el.offsetWidth;
      el.classList.add('flash-highlight');
    }, 300);
  };

  useEffect(() => {
    if (selectedItem.auditNbr) {
      getDocuments(selectedBu, selectedItem, featureName, setListOfDocuments);
    }
  }, [selectedItem]);

  useEffect(() => {
    if (listOfDocuments.length > 0) {
      const result: IDocsForDownload = getDocumentsForDownload(listOfDocuments);

      if (result.documentsEmitted.length > 0) {
        setListOfDocumentsEmitted(result.documentsEmitted);
      } else {
        setListOfDocumentsEmitted([]);
      }
      if (result.documentsAttached.length > 0) {
        setListOfDocumentsAttached(result.documentsAttached);
      } else {
        setListOfDocumentsAttached([]);
      }
    }
  }, [listOfDocuments]);

  const renderSpinner = () => {
    return (
      <div className="spinner-container">
        <AppSpinner
          style={{
            width: 'fit-content',
            margin: 'auto',
            marginTop: '5%',
            marginBottom: '10%',
          }}
        />
      </div>
    );
  };

  const defineLang = () => {
    const dateLanguage =
      (language || user?.language)?.split('-')[0] === 'rs'
        ? 'sr'
        : (language || user?.language)?.split('-')[0];
    return dateLanguage;
  };

  if (errorLoading) {
    return (
      <ModalTemplate
        type="error"
        show={showModal}
        className="reimbursement-detail-error-modal"
        onHide={() => setShowModal(false)}
        hideFooter={true}
        cross={true}>
        <span className="refund-detail-error-text" style={{...fonts.ML}}>
          {labelsMessages.error_loading_detail}{' '}
        </span>
        <div className="refund-detail-error-container">
          <AppButton
            onClick={async () => {
              setShowModal(false);
            }}
            variant="secondary"
            className="refund-detail-error-button">
            Ok
          </AppButton>
        </div>
      </ModalTemplate>
    );
  } else {
    switch (selectedItem.stateId) {
      case '102':
        return (
          <ModalTemplate
            className="reimbursement-detail-modal-in-progress"
            inputType="confirm"
            show={showModal}
            onHide={() => setShowModal(false)}
            onSubmit={() => setShowModal(false)}
            cross={false}>
            {!loadingDetail && (
              <Column className="reimbursement-detail-modal-in-progress-column">
                <Row>
                  {' '}
                  {changedItem && (
                    <ReimbursementSubmissionStatusBar
                      ReimbursementFinishedSubmitting={
                        ReimbursementFinishedSubmitting
                      }
                      sessionId={selectedItem.sessionId}
                      changedItem={changedItem}
                      selectedItem={selectedItem}
                    />
                  )}
                  {!!!changedItem && (
                    <ReimbursementSubmissionStatusBar
                      ReimbursementFinishedSubmitting={
                        ReimbursementFinishedSubmitting
                      }
                      sessionId={selectedItem.sessionId}
                    />
                  )}
                </Row>
                <Header2>
                  {createRefundLabels?.createRefund_readingInProgress}
                </Header2>
                <div>{createRefundLabels?.createRefund_notification}</div>
              </Column>
            )}
            {loadingDetail && renderSpinner()}
          </ModalTemplate>
        );
      case '103':
        return (
          <ModalTemplate
            type="error"
            show={showModal}
            onHide={() => setShowModal(false)}
            hideFooter={true}
            cross={true}>
            {!loadingDetail && (
              <>
                <p style={{color: colors.alertRed, fontWeight: 'bold'}}>
                  {labels?.refundDetail_readingError}
                </p>
                <p>
                  {(expenses && expenses[0]?.errorMessage) ||
                    createRefundLabels?.createRefund_tryLater}
                </p>
                <Row>
                  <AppButton
                    onClick={async () => {
                      setUpdateFlag(!updateFlag);
                      setShowModal(false);
                    }}
                    variant="secondary"
                    className="talk-with-us-modal-button">
                    Ok
                  </AppButton>
                </Row>
              </>
            )}
            {loadingDetail && renderSpinner()}
          </ModalTemplate>
        );
      case '101':
        return <Column></Column>;
      default:
        return (
          <ModalTemplate
            className="reimbursement-detail-modal"
            show={showModal}
            onHide={() => setShowModal(false)}
            cross={true}
            hideFooter={true}>
            {!loadingDetail && (
              <>
                <Header2
                  style={{
                    ...fonts.XL,
                    color: colors.black,
                    fontWeight: 'bolder',
                  }}
                  className="reimbursement-history-modal-header">
                  {labels?.refundHistory_detailsHeader}
                </Header2>
                <Column className="reimbursement-history-modal-subtitle-global-column">
                  <Row className="reimbursement-history-modal-subtitle-row">
                    <Column className="reimbursement-history-modal-subtitle-column">
                      <Row
                        className="reimbursement-history-modal-subtitle-items-title"
                        style={{...fonts.M, color: '#9C9C9C'}}>
                        {labels?.refundDetail_issuedOnUpperCase}
                      </Row>
                      <Row
                        className="rteimbursement-history-modal-subtitle-items-conten"
                        style={{
                          ...fonts.M,
                          ...fonts.SemiBold,
                          color: colors.black,
                        }}>
                        {moment(expenses[0]?.entryDate)
                          .locale(defineLang())
                          .format('DD MMM YYYY')
                          .toUpperCase()}
                      </Row>
                    </Column>
                    <Column
                      className={
                        'reimbursement-history-modal-status-responsive'
                      }>
                      <div className="item-status-container">
                        <ReimbursementListItemStatus
                          stateDescription={
                            currentStatus
                              ? currentStatus.label
                              : selectedItem.state
                          }
                          color={color}
                        />
                      </div>
                    </Column>
                  </Row>
                  {selectedItem.stateId === '4' && (
                    <Column className="refusal-reason">
                      <Row
                        className={'refusal-reason-column'}
                        style={{...fonts.M, color: '#9C9C9C'}}>
                        {labels?.refundDetail_reason.toUpperCase()}{' '}
                      </Row>
                      {listOfDocumentsEmitted.length <= 0 &&
                        getReasons().map((element: string) => (
                          <Row
                            className="reason-desc-container"
                            style={{...fonts.M, color: colors.black}}>
                            {element}
                          </Row>
                        ))}
                      {listOfDocumentsEmitted.length > 0 && (
                        <>
                          <Row
                            className="reason-desc-container"
                            style={{...fonts.M, color: colors.black}}>
                            {labels?.refundDetail_doc_reason}
                          </Row>
                          <div
                            className="reason-check-letter-container"
                            style={{
                              ...fonts.M,
                              ...fonts.SemiBold,
                              color: colors.blue,
                            }}>
                            <span
                              className="check-letter-text"
                              onClick={() => handleScrollToCheckLetter()}>
                              {labels?.refundDetail_checkLetter}
                            </span>
                          </div>
                        </>
                      )}
                    </Column>
                  )}
                  <Row className="reimbursement-history-modal-subtitle-row">
                    {selectedItem.stateId === '6' &&
                      selectedItem.amountPaid >= 0.01 && (
                        <>
                          <Column className="reimbursement-history-modal-subtitle-column">
                            <Row
                              className="reimbursement-history-modal-subtitle-items-title"
                              style={{...fonts.M, color: '#9C9C9C'}}>
                              {labels?.refundDetail_processedOnUpperCase}
                            </Row>
                            <Row
                              className="reimbursement-history-modal-subtitle-items-content"
                              style={{
                                ...fonts.M,
                                ...fonts.SemiBold,
                                color: colors.black,
                              }}>
                              {moment(checkdate)
                                .locale(defineLang())
                                .format('DD MMM YYYY')
                                .toUpperCase()}
                            </Row>
                          </Column>
                        </>
                      )}
                    {!isResponsive &&
                      selectedItem.stateId === '6' &&
                      selectedItem.amountPaid >= 0.01 &&
                      ibanDetails && (
                        <>
                          <Column
                            className={
                              'reimbursement-history-modal-column-responsive'
                            }>
                            <Row
                              className="reimbursement-history-modal-subtitle-items-title"
                              style={{...fonts.M, color: '#9C9C9C'}}>
                              {labels?.refundDetail_destinationIBANUpperCase}
                            </Row>
                            <Row
                              className="reimbursement-history-modal-subtitle-items-content"
                              style={{
                                ...fonts.M,
                                ...fonts.SemiBold,
                                color: colors.black,
                              }}>
                              {ibanDetails.match(/.{1,4}/g)?.join(' ')}
                            </Row>
                            <Row
                              className="reimbursement-history-modal-subtitle-items-title"
                              style={{
                                ...fonts.M,
                                color: '#9C9C9C',
                                textAlign: 'end',
                                marginTop: '6px',
                              }}>
                              {labels?.refundDetail_dateInfo}
                            </Row>

                            <Row></Row>
                          </Column>
                        </>
                      )}
                  </Row>
                  {isResponsive &&
                    selectedItem.stateId === '6' &&
                    selectedItem.amountPaid >= 0.01 &&
                    ibanDetails && (
                      <>
                        <Row className="reimbursement-history-modal-subtitle-row">
                          <Column>
                            <Row
                              className="reimbursement-history-modal-subtitle-items-title"
                              style={{
                                ...fonts.M,
                                color: '#9C9C9C',
                                justifyContent: 'left',
                              }}>
                              {labels?.refundDetail_destinationIBANUpperCase}
                            </Row>
                            <Row
                              className="reimbursement-history-modal-subtitle-items-content"
                              style={{
                                ...fonts.M,
                                ...fonts.SemiBold,
                                color: colors.black,
                                justifyContent: 'left',
                              }}>
                              {ibanDetails.match(/.{1,4}/g)?.join(' ')}
                            </Row>
                            <Row
                              className="reimbursement-history-modal-subtitle-items-title"
                              style={{
                                ...fonts.M,
                                color: '#9C9C9C',
                                textAlign: 'start',
                                marginTop: '6px',
                              }}>
                              {labels?.refundDetail_dateInfo}
                            </Row>
                          </Column>
                        </Row>
                      </>
                    )}
                </Column>
                {/* <ExpensesDetail
                  estadoId={selectedItem.estadoId}
                  process={selectedItem.auditNbr}
                  selectedPatient={`${user.given_name} ${user.family_name}`}
                  occorenceDate={selectedItem.dosFrom}
                  expenses={expenses}
                  provider={selectedItem.providerName}
                  submittedFiles={[]}
                  selectedItem={selectedItem}
                /> */}
              </>
            )}
            {!isLoading && (
              <ExpensesDetail
                listOfDocumentsAttached={listOfDocumentsAttached}
                listOfDocumentsEmitted={listOfDocumentsEmitted}
                estadoId={selectedItem.stateId}
                process={selectedItem.auditNbr}
                selectedPatient={`${user.name}`}
                occorenceDate={selectedItem.dosFrom}
                expenses={expenses}
                provider={selectedItem.providerName}
                submittedFiles={[]}
                selectedItem={selectedItem}
                checkLetterRef={checkLetterRef}
              />
            )}
            {(isLoading || loadingPaymentDetail) && (
              <AppSpinner className="refund-spinner" />
            )}
          </ModalTemplate>
        );
    }
  }
}

const mapStateToProps = ({
  selectedBu,
  strings,
  user,
  globalStyles,
  language,
  iban,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.refund,
  labelsMessages: strings.value.pt.messages,
  createRefundLabels: strings.value.pt.createRefund,
  buStyles: globalStyles.value,
  language: language.value,
  iban: iban?.value,
});

export default compose(connect(mapStateToProps)(ReimbursementsDetail));
